import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDate, usePlan } from "@/lib/plan";

const KEY = "rs_banner_seen";

export function PlanBanner() {
  const { pathname } = useLocation();
  const { data: plan } = usePlan();
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY));
  if (!plan || pathname === "/pro" || pathname.startsWith("/payment")) return null;
  const early = plan.source === "early_supporter";
  const ending = early && plan.days_left <= 3;
  const trialEnding = plan.source === "trial" && plan.subscription?.cancel_at_period_end && plan.subscription?.trial_end;
  let msg = null;
  if (ending) msg = `Your free Pro ends in ${plan.days_left} day${plan.days_left === 1 ? "" : "s"} (${fmtDate(plan.early_supporter_until)}). Keep Pro to stay unlimited.`;
  else if (early && hidden !== "early") msg = `14 days of Pro, on us. Thanks for being an early supporter. ${plan.days_left} day${plan.days_left === 1 ? "" : "s"} left.`;
  else if (trialEnding) msg = `Your trial ends ${fmtDate(plan.subscription.trial_end)} and won't renew.`;
  if (!msg) return null;
  const dismiss = () => {
    localStorage.setItem(KEY, "early");
    setHidden("early");
    api.post("/billing/dismiss-banner").catch(() => {});
  };
  return (
    <div className="mx-4 mt-3 rounded-xl border border-[#E50914]/30 bg-[#E50914]/10 px-4 py-3 flex items-start gap-3 fade-in" data-testid="plan-banner">
            <div className="flex-1 text-[13px] leading-snug">
        <span data-testid="plan-banner-text">{msg}</span>{" "}
        {(early || trialEnding) && <Link to={trialEnding ? "/profile" : "/pro"} className="font-semibold underline underline-offset-2" data-testid="plan-banner-cta">{trialEnding ? "Manage →" : "Keep Pro →"}</Link>}
      </div>
      {!ending && !trialEnding && <button onClick={dismiss} aria-label="Dismiss" className="text-[#A1A1AA] -mr-1" data-testid="plan-banner-dismiss"><X size={16} /></button>}
    </div>
  );
}
